<template>
  <div
    class="modal fixed inset-0 flex items-center justify-center fader overflow-hidden h-full"
  >
    <div
      class="h-full clear-both max-h-full max-h-modal w-full lg:max-w-5xl bg-white shadow-md text-center lg:rounded px-2 sm:px-10 pt-10 relative overflow-auto"
    >
      <button
        type="button"
        class="close-btn absolute text-gray-800 hover:text-blue-800 top-2 right-2 px-1 py-1"
        @click="close"
      >
        <icon name="close" width="20" height="20"></icon>
      </button>
      <a
        :href="siteData.reflink"
        target="_blank"
        class="sm:float-left sm:mr-4 mb-4 inline-block"
        :style="{ height: siteData.image.title + 'px' }"
      >
        <img :src="siteData.image.filename" :alt="siteData.image.alt" />
      </a>
      <div
        v-if="loading"
        class="flex flex-grow items-center justify-center mt-6"
      >
        <Loader />
      </div>
      <div v-if="!loading">
        <h2 class="text-2xl font-bold text-center mb-2 mt-2 sm:mt-0">
          <a
            :href="siteData.reflink"
            target="_blank"
            class="text-blue-800 hover:text-blue-600 inline-block"
            >{{ siteData.url }}</a
          >
        </h2>

        <p class="text-left">{{ siteData.intro }}</p>
        <div class="text-left mt-4">
          <span class="font-bold text-gray-700">Вывод денег</span>
          <p class="mt-2">{{ siteData.withdrawal }}</p>
        </div>
        <div class="text-left mt-4">
          <span class="font-bold text-green-700">Плюсы этого сайта</span>
          <p class="mt-2">{{ siteData.plus }}</p>
        </div>
        <div class="text-left mt-4">
          <span class="font-bold text-red-700">Минусы этого сайта</span>
          <p class="mt-2">{{ siteData.minus }}</p>
        </div>
        <div class="text-left mt-4">
          <span class="font-bold text-yellow-700">Советы по этому сайту</span>
          <p class="mt-2">{{ siteData.advice }}</p>
        </div>
      </div>
      <div class="mt-4 flex justify-between pb-10">
        <a
          :href="siteData.reflink"
          target="_blank"
          class="text-blue-800 hover:text-blue-600"
          >Посетить {{ siteData.url }}</a
        >
        <button
          type="button"
          @click="close"
          class="hover:text-blue-600 font-bold"
        >
          Закрыть
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {token, storyapi} from "@/api"
import Loader from "@/components/Loader.vue";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      siteData: {
        title: '',
        image: {
          title: '',
          filename: '',
          alt: ''
        },
        reflink: '',
        url: '',
        intro: '',
        withdrawal: '',
        plus: '',
        minus: '',
        advice: ''
      },
    };
  },
   created() {
    // Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token,
    });
    window.storyblok.on("change", () => {
      this.getStory("draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getStory("draft");
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getStory("published");
      }
    });
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    close() {
      this.$store.commit("toggleModal");
    },
    getStory() {
      this.$store.commit("toggleLoading");
      storyapi
        .get("cdn/stories", {
          starts_with: "summaries/",
          filter_query: {
            Site: {
              in: this.$store.state.site.id,
            },
          },
          version: this.$store.state.version,
        })
        .then((response) => {
          this.siteData = {
            ...response.data.stories[0].content,
            title: this.$store.state.site.title,
          };
          this.$store.commit("toggleLoading");
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("toggleLoading");
        });
    },
  },
};
</script>

<style scoped lang="scss">
p {
  text-indent: 1rem;
}
@media (min-width: 1024px) {
  .max-h-modal {
    max-height: 90%;
  }
}
</style>